// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zY2K","index":"styles_index__1_sJO"};